import type { FaireProductEntity } from "../../entity_types/product";

export const p_5drrqf5fx5: FaireProductEntity = {
  token: "p_5drrqf5fx5",
  type: "product",
  name: "Single Origin Central/South America",
  brandToken: "b_cgzjcth7hb",
  brandName: "Four Barrel Coffee",
  imageUrl: "https://cdn.faire.com/fastly/b01f03ff61d7713e34d3714a8d51942b18f1f31b91a7c1dcdf1993d5663f86eb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4edd00aa0c192186577a9ff06448e84c56ef803905c38580e86e2c247a22047a.jpeg"
  ],
  priceDollars: 28,
  description: "Our menu is ever rotating and we always are roasting some beautiful and delicious coffees. Our single origin Central/South American coffees come from Guatemala, Nicaragua, El Salvador, and Honduras and are always rotating.\nPlease reach out if you are looking for a particular origin.\n\nTo check out our current offerings, please go to our website: www.fourbarrelcoffee.com",
  tags: [],
  msrpDollars: 56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:36.876Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
